import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const SETTINGS_CACHE_KEY = 'kanbr_settings_cache';

export function useSiteSettings() {
    const [settings, setSettings] = useState(() => {
        try { return JSON.parse(localStorage.getItem(SETTINGS_CACHE_KEY) || 'null'); } catch { return null; }
    });

    useEffect(() => {
        api.get('/settings').then((r) => {
            setSettings(r.data);
            localStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify(r.data));
        }).catch(() => {});
    }, []);

    return settings || {
        whatsapp_number: '919773704406',
        business_email: 'kanbr.concepts@gmail.com',
        factory_address: 'Plot No 267, Phase IV, Sector 57, HSIIDC, Kundli, Sonipat 131028',
        ga_measurement_id: '',
        meta_pixel_id: '',
        shipping_flat: 1500,
        advance_percent: 10,
    };
}

export function buildWhatsAppUrl(number, message) {
    const cleaned = String(number || '919773704406').replace(/\D/g, '');
    return `https://wa.me/${cleaned}?text=${encodeURIComponent(message || 'Hi Kanbr team, I want to know more about your offerings.')}`;
}
